import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CalendarPicker } from '@mui/x-date-pickers/CalendarPicker';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import AdminNavbar from '../../components/AdminNavbar';
import Grid from '@mui/material/Grid';
import { db } from '../../firebase';
import { addDoc, collection, deleteDoc, doc, getDocs, setDoc, updateDoc, onSnapshot, query, deleteField } from 'firebase/firestore';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { getCalendarOverwrites } from '../../helpers';

const locationCollection = collection(db, 'locations');

export default function Calendar() {
  const [locations, setLocations] = useState([]);
  const [overwrites, setOverwrites] = useState([]);
  const [locationValue, setLocationValue] = useState("sydney");
  const [time, setTime] = useState({
    from: '',
    to: ''
  });
  const [date, setDate] = useState();

  const dateStr = date?.format('YYYY-MM-DD');
  const overwrite = overwrites.find((d) => d.date === dateStr);
  const docRef = dateStr ? doc(db, `locations/${locationValue}/calendarOverwrites/${dateStr}`) : null;

  const checkCalendar = async () => {
    setOverwrites(
      await getCalendarOverwrites(locationValue)
    );
  }

  useEffect(() => {
    if (overwrite?.time) {
      setTime({
        from: overwrite?.time?.from,
        to: overwrite?.time?.to
      });
    } else {
      setTime({
        from: '',
        to: ''
      });
    }
  }, [dateStr]);

  // Initialize locations
  useEffect(() => {
    onSnapshot(query(locationCollection), (querySnapshot) => {
      const list = [];
      querySnapshot.forEach((doc) => {
        list.push({ ...doc.data(), id: doc.id });
      });
      setLocations(list);
    });
  }, []);

  // Initialize disabled dates
  useEffect(() => {
    checkCalendar();
  }, [locationValue]);


  const handleChange = (event) => {
    setLocationValue(event.target.value)
  };
  const toggleBlockUnblock = async () => {
    // Block toggle
    await setDoc(docRef, {
      blocked: !overwrite?.blocked,
      date: dateStr,
    }, {
      merge: true,
    });
    
    // Refresh
    checkCalendar();
  };

  const updateTimeToggle = async () => {

    await setDoc(docRef, {
      time: overwrite?.time ? deleteField() : time,
      date: dateStr,
    }, {
      merge: true,
    });

    // Refresh
    checkCalendar();
  }

  return (
    <>
      <AdminNavbar />
      <br />
      <div className='adminPage'>
        <FormControl sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="demo-simple-select-helper-label">Location</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={locationValue}
            defaultValue={'sydney'}
            label="Location"
            onChange={handleChange}
            required
          >
            {
              locations.map((location) => <MenuItem key={location.id} value={location.id}>{location.name}</MenuItem>)
            }
          </Select>
          <FormHelperText>Select the location</FormHelperText>
        </FormControl>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CalendarPicker
            disablePast
            renderDay={(day, selectedDates, pickersDayProps) => {
              const isDisabled = overwrites.some((d) => d.date === day.format('YYYY-MM-DD') && d.blocked);
              const isSelectedDateDisabled = selectedDates?.[0]?.format('YYYY-MM-DD') === day.format('YYYY-MM-DD')
              return (
                <PickersDay
                  {...pickersDayProps}
                  {...(isDisabled && {
                    style: {
                      backgroundColor: isSelectedDateDisabled ? '#8b0000' : 'red',
                      color: 'white'
                    }
                  })} />
              );
            }}
            date={date}
            onChange={(newDate) => setDate(newDate)} />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TextField
            id="time"
            label="From"
            type="time"
            onChange={(event) => setTime({ ...time, from: event.target.value })}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              step: 300, // 5 min
            }}
            value={time?.from}
            sx={{ width: 150 }}
          />
          <> </>
          <TextField
            id="time"
            label="To"
            type="time"
            onChange={(event) => setTime({ ...time, to: event.target.value })}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              step: 300, // 5 min
            }}
            value={time?.to}
            sx={{ width: 150 }}
          />
        </LocalizationProvider>
        <Box sx={{ '& button': { m: 1 } }}>
          <div className='adminBtns'>
            <Button
              disabled={locationValue == null || date == null}
              variant="contained"
              size="large"
              onClick={toggleBlockUnblock}
            >
              {overwrite?.blocked ? 'Unblock' : 'Block'}
            </Button>
            <Button
              onClick={updateTimeToggle}
              disabled={(!locationValue || !date || !time)}
              variant="contained"
              size="large"
            >
              {overwrite?.time ? 'Clear Custom Hours' : 'Set Custom Hours'}
            </Button>
          </div>
        </Box>
      </div>
    </>
  );
}
